import { render, staticRenderFns } from "./UeberNewIcon.vue?vue&type=template&id=8593fa56&scoped=true&"
var script = {}
import style0 from "./UeberNewIcon.vue?vue&type=style&index=0&id=8593fa56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8593fa56",
  null
  
)

export default component.exports